import EventBus from '../services/service.eventBus';
import { getIsOptimizelyTrue } from '../services/service.optimizely';
import { state as optimizelyState } from '../store/store.optimizely';

const onOptimizelyCertificateOptimizedLeadRoutingCheck = async () => {
  try {
    await onOptimizelyCertificateOptimizedLeadRoutingCheckSuccess();
  } catch (error) {}
};

const onOptimizelyCertificateOptimizedLeadRoutingCheckSuccess = async () => {
  const ret = await getIsOptimizelyTrue('optimizedleadrouting', 'optimizedleadrouting');
  optimizelyState.optimizedleadrouting = ret.data.variableValue;
};

const onOptimizelyCertificateUIEnhancementCheck = () => {
  onOptimizelyCertificateUIEnhancementCheckSuccess();
};

const onOptimizelyCertificateUIEnhancementCheckSuccess = () => {
  optimizelyState.icocertenhancementsOptimizely = true;
};

const onOptimizelyConsumerMarketConfidenceCheck = async () => {
  try {
    EventBus.publish('OptimizelyCheck', 'ConsumerMarketConfidence');
    await onOptimizelyConsumerMarketConfidenceCheckSuccess();
  } catch (error) {
    EventBus.publish('onOptimizelyConsumerMarketConfidenceCheckFail', error);
  }
};

const onOptimizelyConsumerMarketConfidenceCheckSuccess = async () => {
  const ret = await getIsOptimizelyTrue('enablecmc', 'isConsumerMarketConfidenceOn');
  optimizelyState.isConsumerMarketConfidenceOn = ret.data.variableValue;
  EventBus.publish('onOptimizelyConsumerMarketConfidenceCheckSuccess', ret);
};

const onOptimizelyAcceptOrCounterofferCheck = async () => {
  try {
    await onOptimizelyAcceptOrCounterofferSuccess();
  } catch (error) {
    onOptimizelyAcceptOrCounterofferFail(error);
  }
};

const onOptimizelyAcceptOrCounterofferSuccess = async () => {
  EventBus.publish('OptimizelyCheck', 'AcceptOrCounteroffer');

  const ret = await getIsOptimizelyTrue('acceptorcounteroffer', 'isEnabled');
  optimizelyState.acceptOrCounterofferON = ret.data.variableValue;
  const res = await getIsOptimizelyTrue('AcceptOrCounterOfferUnassigned', 'isEnabled');
  optimizelyState.acceptOrCounterofferUnassignedON = res.data.variableValue;
  EventBus.publish('onOptimizelyAcceptOrCounterofferSuccess', ret);
};

const onOptimizelyAcceptOrCounterofferFail = (error) => {
  EventBus.publish('onOptimizelyAcceptOrCounterofferFail', error);
};

const actions = {
  onOptimizelyCertificateUIEnhancementCheck,
  onOptimizelyAcceptOrCounterofferCheck,
  onOptimizelyCertificateOptimizedLeadRoutingCheck,
  onOptimizelyConsumerMarketConfidenceCheck,
};

export { actions };
export default actions;
